@if (!button) {
  <div class="row">
    <div class="col-md-12">
      <h3>{{ name }}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 min">
      @if (address) {
        {{ address.street }}<br/>
        {{ address.zip }} {{ address.city }}<br/>
        {{ address.country }}
      }
      @if (!address && addresses?.length > 0) {
        <div class="alert alert-danger">
          Bitte wählen
        </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      @if (rights) {
        <button class="btn btn-default btn-sm" (click)="open()" [disabled]="isEmpty()">
          Bearbeiten
        </button>
      }
    </div>
  </div>
}

<!-- renders the whole component as a button box-->
@if (button) {
  <div class="btn btn-default button-box-text" (click)="open()" [ngClass]="{click: !isEmpty()}">
    @if (address) {
      {{ address.street }}<br/>
      {{ address.zip }} {{ address.city }}<br/>
      {{ address.country }}
    }
  </div>
}
